<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'请输入记录内容',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetRecordInfo();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetRecordInfo()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增记录'}" @finish="AddRecord()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-record-obj">
        <el-table :data="recordlist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="序号" type="index" min-width="50" align="center" />
            <el-table-column label="类型" align="center" v-if="pagelabel.typeavar">
                <template #default="scope">
                    <wcimage :value="scope.row.typeavar" :option="{size:'middle'}" />
                </template>
            </el-table-column>
            <el-table-column label="类型名称" align="center" prop="typename" v-if="pagelabel.typename"/>
            <el-table-column label="所属商户" align="center" prop="shopname" v-if="pagelabel.shopname"/>
            <el-table-column label="记录宠物" align="center" prop="petname" v-if="pagelabel.petname"/>
            <el-table-column label="记录时间" align="center" prop="inputtime" v-if="pagelabel.inputtime"/>
            <el-table-column label="操作" align="center" fixed="right" min-width="180">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'详情'}" @finish="RecordDetail(scope.row.id)" class="left10" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelRecord(scope.row.id)" class="left10" />
                    <!--
                    <wcbutton :option="{title:'编辑'}" @finish="EditRecord(scope.row.id)" class="left10" />
                    -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetRecordInfo();
                    }"
                />
            </div>
        </div>
    </div>

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'Record'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />

</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import INTERFACE_MODEL_RECORD from '@/Interface/Record/Record';
export default {
    components:{
        Pagelabel
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            recordlist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除记录'},
                {id:2,name:'批量修改记录'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.Getpagelabel();      //获取页面显示标签信息
            this.GetRecordInfo(); //获取记录信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetRecordInfo(); //获取记录信息
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetRecordInfo(); //获取记录信息
            }else {
                this.GetRecordInfo(); //获取记录信息
            }
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的记录',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelRecorddata(ids);
                }else if(index==2) {
                    this.EditMemberMore(ids);
                }
               
            }).catch(()=> {
                
            });

        },


        /** 删除记录信息 **/
        DelRecord(ids) {
            this.DelRecorddata(ids);
        },


        /** 删除记录信息操作 **/
        DelRecorddata(ids) {
            INTERFACE_MODEL_RECORD.Del_record({ids:ids}).then((res) => {
                if(res.status > 0) return false;
                this.GetRecordInfo(); //获取记录信息
            });
        },

        
        /** 编辑单个记录 **/
        EditRecord(id) {
            this.EditRecorddata(id);
        },


        /** 编辑多个记录 **/
        EditMemberMore(ids) {
            this.EditRecorddata(ids);
        },


        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        //获取记录信息列表
        GetRecordInfo() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-record-obj");
            this.$loading.openloading(obj);

            INTERFACE_MODEL_RECORD.GET_RECORD_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.recordlist=res.data.list;
            });
        },


        //新增记录类型
        RecordType() {
            var navinfo={name:'记录类型管理',labelentry:'RecordType',components:'RecordType',isshow:false};
            var data={Method:'',delcomponent:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 新增记录 **/
        AddRecord() {
            var navinfo={name:'新增记录',labelentry:'AddRecord',components:'AddRecord',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑记录信息 **/
        EditRecorddata(ids) {
            var navinfo={name:'编辑记录',labelentry:'EditRecord',components:'EditRecord',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 记录信息详情 **/
        RecordDetail(id) {
            var navinfo={name:'记录详情',labelentry:'RecordDetail',components:'RecordDetail',isshow:false};
            var data={Method:'',id:id};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.recordlist.length;i++) this.recordlist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.recordlist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.recordlist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('Record',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-table-content {display: inline-block;width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.TTL-popover-show {display: inline-block;width:100%;}
.TTL-popover-showinfo {display: inline-flex;justify-content: left;align-items: center;}
.TTL-popover-showinfo .el-image {width:60px;height:60px;border-radius: 50%;}
.TTL-popover-showinfo .showname {font-size: 13px;margin-left:15px;}
.TTL-popover-showinfo {border-bottom:1px solid #F0F2F5;padding:15px 0;}
.TTL-popover-showinfo:last-child {border-bottom:none;}
.TTL-btn-list {display:inline-flex;}
</style>